import mapboxgl from 'mapbox-gl'

export default {
    props: {
        applyLocateUser: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            geolocateControl: null,
        }
    },
    methods: {
        handleLocateUser() {
            if (!this.geolocateControl) {
                this.geolocateControl = new mapboxgl.GeolocateControl({
                    positionOptions: {
                        enableHighAccuracy: true
                    },
                    trackUserLocation: true
                })
            }
            if (this.applyLocateUser) {
                this.mySmartMap.addControl(this.geolocateControl)
            } else if (this.mySmartMap.hasControl(this.geolocateControl)) {
                this.mySmartMap.removeControl(this.geolocateControl)
            }
        },
        triggerLocateUser() {
            this.geolocateControl.trigger()
        }
    },
    watch: {
        applyLocateUser() {
            this.handleLocateUser()
        }
    }
}